
import IconLine from '~/components/icons/IconLine.vue';
export default {
  components: { IconLine },
  props: {
    number: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    noLine: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
};
